import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuth: false,
    userProfile: [],
    username: ""
  },
  getters: {
    ISAUTH: state => { return state.isAuth },
    USERPROFILE: state => { return state.userProfile },
    NAME: state => { return state.username }

  },
  mutations: {
    LOG_IN: (state) => { state.isAuth = true },
    LOG_OUT: (state) => {
      state.isAuth = false
      state.userProfile = []
      state.username = ""
    },
    STORE_USERPROFILE: (state, userrights) => { state.userProfile = userrights },
    STORE_NAME: (state, username) => { state.username = username },


    //legacy functions
    logOut: state => { state.isAuth = false },
    logIn: state => { state.isAuth = true },
    userRights: (state, rights) => { state.userProfile = rights },
  },
  actions: {

  }
})
